import React, { useEffect, useState } from 'react';
import getSupportEmailLinkForReportingError from '../../../services/mini/email/getSupportEmailLinkForReportingError';
import errImg from '../../../assets/images/error_fallback/icon-serverless-architecture.svg';
import { Loader} from '../Loader/Loader';

function setWithExpiry(key, value, ttl) {
    const item = {
        value: value,
        expiry: new Date().getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
    const itemString = window.localStorage.getItem(key);
    if (!itemString) return null;

    const item = JSON.parse(itemString);
    const isExpired = new Date().getTime() > item.expiry;

    if (isExpired) {
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

export function ErrorFallback({ error, componentStack }) {

    const [showReloadPageFallback, setShowReloadPageFallback] = useState(false);

    useEffect(() => {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (error?.message && chunkFailedMessage.test(error.message)) {
            if (!getWithExpiry("chunk_failed")) {
                setWithExpiry("chunk_failed", "true", 10000);
                setShowReloadPageFallback(true);
                window.location.reload();
            }
        }
    }, [error]);

    if (showReloadPageFallback) {
        return (
            <div className="ErrorFallback" role="alert">
                <Loader theme="dark" size="medium" center={true} appearWithFade={true} />
                <h1 className="ErrorFallback__title">
                    A new version of Alan AI Studio is available!
                </h1>
                <div className="ErrorFallback__msg">
                    Wait a second, we will set up things for you
                </div>
            </div>
        );
    }

    return (
        <div className="ErrorFallback" role="alert">
            <img className="ErrorFallback__img" src={errImg} />
            <h1 className="ErrorFallback__title">Oooops!</h1>
            <div className="ErrorFallback__msg">Something went wrong, but we are aware of it and working on the fix</div>
            <a className="ErrorFallback__refresh-btn action-btn" href={window.location.href}>
                Try to refresh the page later
            </a>
            {error &&
                <a
                    className="ErrorFallback__support-link"
                    href={getSupportEmailLinkForReportingError(error, componentStack)}>Contact support</a>
            }
        </div>
    );
}